import { render, staticRenderFns } from "./ProviderFee.vue?vue&type=template&id=4dde51f1&lang=pug&"
import script from "./ProviderFee.vue?vue&type=script&lang=js&"
export * from "./ProviderFee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports